import * as React from "react"
import { useEffect } from "react"
import { Box } from "@mui/material"

import { CommonFilters } from "@components"
import {COMMON_FILTER_KEYS, PRICING_ROUTES, PRODUCT_PAGE_ROUTES} from "@constants"
import { useAppDefaultFilters } from "@hooks"
import { usePricingChangesFilters } from "./@hooks"


export default function PricingChangesFilters() {
	const { handleSubmit } = usePricingChangesFilters()
	const { callUserDefaultFilters, userFilters, isLoadingDefaultFilters } = useAppDefaultFilters(PRICING_ROUTES.CHANGES_ID, PRICING_ROUTES.ACCESS_KEY)

	useEffect(() => {
		callUserDefaultFilters()
	}, [])

	return <Box data-tour="pricing-changes-filters">
	<CommonFilters
		components={{
			currentPrevDates: true,
			country: true, site: true,
			category: true, brand: true,
			sku: true, skuGroup: true,
			favFilters: true, productsInStock: true,
			withShippingPrice: true, favFiltersOnlyLine: true
		}}
		compProps={{
			spaceSinglesDate: { grid: { xs: 0, md: 0 } },
			previousSingleDate: { grid: { xs: 3, md: 2 } },
			currentSingleDate: { grid: { xs: 2, md: 2 } },
			productsInStock: { grid: { md: 2, xs: 2 } },
			withShippingPrice: { grid: { md: 4, xs: 4 }},
			sku: { grid: { md: 6 } },
			favFiltersOnlyLine: { grid: { xs: 10, md: 10 }},
			favFilters: {
				grid: {md: 2, xs: 2 },
				allowedFilters: [
					COMMON_FILTER_KEYS.COUNTRY, COMMON_FILTER_KEYS.RETAILER, COMMON_FILTER_KEYS.CATEGORY, COMMON_FILTER_KEYS.BRAND,
					COMMON_FILTER_KEYS.SKU_GROUP, COMMON_FILTER_KEYS.SKU, COMMON_FILTER_KEYS.INCLUDE_SHIPPING_PRICE,
					COMMON_FILTER_KEYS.PRODUCTS_IN_STOCK
				],
				dashboardKey: PRICING_ROUTES.CHANGES_ID
			},
		}}

		onSubmit={handleSubmit}
		defaultValues={userFilters}
		isLoadingDefaultFilters={isLoadingDefaultFilters}
	/>
	</Box>
}